/** Used to get all values if multiple of the same name exists in the Form */
export const getFormData = (formData: FormData) => {
  const data = Object.fromEntries(formData) as Record<
    string,
    FormDataEntryValue | FormDataEntryValue[]
  >

  const dataKeys = Object.keys(data)

  dataKeys.forEach((key) => {
    const dataArray = formData.getAll(key)

    if (dataArray.length > 1) {
      data[key] = dataArray
    }
  })

  return data
}
